/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "../order/order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import { useEffect } from "react";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { AcceptIcon } from "../../../component/icons/icons";
import { value } from "jsonpath";
import { FormControl, InputLabel } from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UriEncode from "../../../component/uriEncode/uriEncode";
import DraggableResizablePaper from "../../../component/resizablePaper/resizablePaper";
// import { makeStyles } from '@mui/styles';

// Get adjustment props from parent
const SubscriptionDialog = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [subscriptions, setSubscriptions] = useState([]);
  const [renderSubscription, setRenderSubscription] = useState(false);

  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();

  const [data, setData] = useState({
    name: "",
    invoiceId: "",
    type: "",
    subscriptionId: "",
    value: { amount: "" },
    notes: "",
    accountId: props.customerDetails.ban,
    partyId: props.customerDetails.partyId,
  });

  const onChange = (e) => {
    var tempData = { ...data };
    if (e.target.name === "value") {
      tempData.value.amount = e.target.value;
    } else {
      tempData[e.target.name] = e.target.value;
    }
    setData(tempData);
  };

  useEffect(() => {
    if (props.isEdit) {
      setData({ ...props.adjustment });
    }
  }, [props]);

  useEffect(() => {
    getSubscriptions();
  }, []);

  const getSubscriptions = () => {
    setLoading(true);
    BusApiCall(
      "GET",
      `${constants.busV4Url}/customers/${UriEncode(props.customerDetails.ban)}/client/${props.customerDetails.partyId}/subscriptions`,
      {},
    )
      .then((res) => {
        let list = res.data.subscriptions;
        setSubscriptions(list);
        setLoading(false);
        setRenderSubscription(true);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
      });
  };

  const createAdjustment = async () => {
    setMsg("");
    setLoading(true);
    if (validateAdjustmentData()) {
      var payload = { ...data };
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/subscriptionAdjustments`,
        payload,
      )
        .then((res) => {
          setLoading(false);
          props.close("add");
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.data && err.response.data.message) {
            setMsg(err.response.data.message);
          } else {
            setMsg(t("DEFAULT_ERROR_MESSAGE"));
          }
        });
    } else {
      setLoading(false);
      setMsg(t("MANDATORY_FIELDS_MESSAGE"));
    }
  };

  const validateAdjustmentData = () => {
    if (
      data.name === "" ||
      data.type === "" ||
      data.subscriptionId === "" ||
      data.value.amount === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  // Update state data on input change
  const updateAdjustment = async () => {
    setMsg("");
    setLoading(true);
    if (validateAdjustmentData()) {
      var payload = { ...data };
      payload.operation = "edit";
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/subscriptionAdjustments/${props.adjustment.adjustmentId}`,
        payload,
      )
        .then((res) => {
          setLoading(false);
          props.close("edit");
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.data && err.response.data.message) {
            setMsg(err.response.data.message);
          } else {
            setMsg(t("DEFAULT_ERROR_MESSAGE"));
          }
        });
    } else {
      setLoading(false);
      setMsg(t("MANDATORY_FIELDS_MESSAGE"));
    }
  };
  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        maxWidth={"md"}
        fullWidth={true}
        open={props.isOpen}
        // PaperComponent={DraggableDialogPaper}
        PaperComponent={DraggableResizablePaper}
        // PaperProps={{
        //     className: classess.resizablePaper
        // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {props.isEdit
                ? t("UPDATE_SUBSCRIPTION_ADJUSTMENT")
                : t("ADD_SUBSCRIPTION_ADJUSTMENT")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => props.close(false)}
                onClick={() => props.close(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"name"}
                placeholder={t("ADJUSTMENT_NAME") + "*"}
                value={data.name}
                onChange={(e) => {
                  onChange(e);
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"invoiceId"}
                placeholder={t("INVOICE_ID")}
                value={data.invoiceId}
                onChange={(e) => {
                  onChange(e);
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <FormControl
                variant="outlined"
                className="custom-select-input"
                size={"small"}
              >
                <InputLabel htmlFor="adjustmentType">
                  {t("ADJUSTMENT_TYPE")} *
                </InputLabel>
                <Select
                  native
                  label="adjustmentType"
                  value={data.type}
                  onChange={(e) => {
                    onChange(e);
                  }}
                  inputProps={{
                    name: "type",
                    id: "adjustmentType",
                  }}
                >
                  <option value="" disabled>
                    {t("ADJUSTMENT_TYPE")}
                  </option>
                  {props &&
                    props.typeList &&
                    props.typeList.map((a, index) => (
                      <option key={index} value={a.value}>
                        {a.value}
                      </option>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              {renderSubscription && (
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="subscriptionList">
                    {t("SUBSCRIPTIONS")} *
                  </InputLabel>
                  <Select
                    native
                    label="subscriptions"
                    value={data.subscriptionId}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    inputProps={{
                      name: "subscriptionId",
                      id: "subscriptionList",
                    }}
                  >
                    <option value="" disabled>
                      {t("SUBSCRIPTIONS")}
                    </option>
                    {subscriptions &&
                      subscriptions.map((a, index) => (
                        <option key={index} value={a.subscriptionId}>
                          {a.productName} ({a.orderId})
                        </option>
                      ))}
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"value"}
                placeholder={t("ADJUSTMENT_VALUE") + " *"}
                value={data.value.amount}
                onChange={(e) => {
                  onChange(e);
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                inputClass={classes.inputClass}
                name={"notes"}
                rows={4}
                multiline={true}
                placeholder={t("NOTES")}
                value={data.notes}
                onChange={(e) => {
                  onChange(e);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div style={{ width: "100%" }}>
            <div style={{ float: "left" }}>
              <span style={{ fontWeight: "bold", color: "#f44336" }}>
                {msg}
              </span>
            </div>
            <div style={{ float: "right" }}>
              {/* <Button onClick={() => { props.close(false); }} style={{ marginRight: '8px' }}>
                                {t('CANCEL')}
                            </Button> */}
              {props.isEdit ? (
                <Button
                  onClick={() => {
                    updateAdjustment();
                  }}
                >
                  {t("UPDATE")}
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    createAdjustment();
                  }}
                >
                  {t("SUBMIT")}
                </Button>
              )}
            </div>
            <div style={{ clear: "both" }}></div>
          </div>
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(SubscriptionDialog);
